import { render, staticRenderFns } from "./PrintedDocuments.vue?vue&type=template&id=618953dd&"
import script from "./PrintedDocuments.vue?vue&type=script&lang=ts&"
export * from "./PrintedDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./PrintedDocuments.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports